import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiClientConstant } from '@cureskin/api-client/src/constant/api-client.constant';
import { BroadcastService } from '@services/broadcast-service';
import { ConnectionService } from '@services/connection-service';
import { EventLoggerService } from '@services/event-logger-service';
import { FirebaseAndBranchEvent } from '@services/event-logger-service/event-logger.constant';
import { ExperimentService } from '@services/experiment/experiment.service';
import { UserAllocatedDoctorService } from '@services/user-allocated-doctor-service/user-allocated-doctor.service';
import { DoctorProfile } from '@cureskin/api-client-rn';

import { AllocatedRegimen } from '../../app-constant-types';
import { AppConfig } from '../../app.config';

@Component({
  selector: 'user-regimen-doctor',
  templateUrl: './user-regimen-doctor.html',
  standalone: false,
})
export class UserRegimenDoctorComponent {
  regimen: any;
  user: any;
  loading: boolean = true;
  offerTimer: any = {};
  allocatedDoctor: DoctorProfile;
  byPassLocalFetch: boolean = false;
  constructor(private eventLogger: EventLoggerService,
    private appConfig: AppConfig,
    private conn: ConnectionService,
    private router: Router,
    private broadcast: BroadcastService,
    private route: ActivatedRoute,
    private readonly experimentService: ExperimentService,
    private readonly userAllocatedDoctorService: UserAllocatedDoctorService) {}

  async ngOnInit(): Promise<void> {
    const regimenClass = this.route.snapshot.queryParams.class;
    const { regimenId }: any = this.route.snapshot.queryParams;
    this.user = await this.conn.getActingUser();
    this.byPassLocalFetch = true;
    const regimens = await this.conn.fetchRegimens(regimenId, true, this.byPassLocalFetch);
    this.regimen = regimens.find((each: AllocatedRegimen): boolean => each.class === regimenClass);
    this.regimen.totalMRP = this.regimen.fixedPriceMRP;
    this.regimen.totalSP = this.regimen.fixedPrice;
    this.regimen.discount = Math.floor(((this.regimen.totalMRP - this.regimen.totalSP) * 100) / this.regimen.totalMRP);
    if (this.user.get('allocatedDoctor')) {
      this.allocatedDoctor = await this.userAllocatedDoctorService.getAllocatedDoctor();
    }
    this.loading = false;
  }

  buyRegimen(): void {
    this.eventLogger.trackInParse('BUY_NOW', ApiClientConstant.Event.Type.ORDER);
    this.eventLogger.trackEventForClass(FirebaseAndBranchEvent.BUY_NOW_CLICKED, this.regimen.class);
    this.eventLogger.trackInFirebaseAndBranchForClass(FirebaseAndBranchEvent.BUY_NOW_CLICKED, this.regimen.class);
    const orderState = this.user?.get('orderState');
    this.router.navigate(['/user/checkout'],
      { queryParams: { type: 'REGIMEN', regimenId: this.regimen.regimenId, useCureSkinCash: String(this.experimentService.shouldUseCureSkinCash(orderState)) }, replaceUrl: true });
  }

  back(): void {
    this.broadcast.broadcast('NAVIGATION_BACK');
  }
}
